import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import classnames from 'classnames';
import type { Icon } from '@personly/libs-types';
import { IconView } from '@personly/libs-widgets';
interface Props {
  children: ReactNode;
  icon?: Icon;
  legend: boolean;
  orientation: 'row' | 'column';
}
const TableHeader = t0 => {
  const $ = _c(11);
  const {
    children,
    icon,
    legend,
    orientation
  } = t0;
  const t1 = legend || !legend && orientation === "column";
  const t2 = orientation === "row";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = classnames({
      flex: true,
      "flex-row": true,
      "flex-1": true,
      "place-items-center": true,
      "items-center": true,
      "font-bold": true,
      "!text-record-header-color": t1,
      "justify-center": t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const className = t3;
  let t4;
  if ($[3] !== icon) {
    t4 = icon && <span className="flex items-center pr-2"><IconView icon={icon} size="lg" /></span>;
    $[3] = icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <div className="flex">{t4}{children}</div>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== className || $[9] !== t5) {
    t6 = <div className={className}>{t5}</div>;
    $[8] = className;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default TableHeader;